import $ from 'jquery';
import React from 'react';
import PropTypes from 'prop-types';
import pgrid from 'projection-grid';
import { iframeDownload } from '@bingads-webui/download-service';
import { uiBlockerPlugin } from '@bingads-webui/projection-grid-uiblocker';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getHotelCenterShared } from '@bingads-webui-campaign/hotel-center-shared';
import { placeholderPlugin } from '@bingads-webui/projection-grid-placeholder';
import { paginationPlugin } from '@bingads-webui/projection-grid-pagination';
import { perfMarkerPlugin } from '@bingads-webui-campaign/pgrid-performance-log';
import { a11yPlugin } from '@bingads-webui/projection-grid-a11y';
import { notificationApi } from '@bingads-webui-campaign/notification-center';
import pageContext from '@bingads-webui-static-legacy/page-context';
import state from '@bingads-webui-component-legacy/state/index';
import * as dateFilterPreferences from '@bingads-webui-component-legacy/bingads-grid/service/date-filter-preferences';

import { GridOption } from './grid-option';
import getStyles from './style/index';

class HotelCenterReconReportGrid extends React.PureComponent {
  constructor(props) {
    super(props);
    this.dateFilterRef = React.createRef();
    this.gridrRef = React.createRef();
    this.floatingBanner = null;
  }

  componentDidMount() {
    const { i18n, reportType, perfMarker } = this.props;

    const { dateFilterPlugin } = getHotelCenterShared({
      i18n,
      pageContext,
      state,
      dateFilterPreferences,
    });

    const gridOption = new GridOption({
      i18n, reportType, dateFilterContainer: $(this.dateFilterRef.current), perfMarker,
    });
    let grid = pgrid.factory({ vnext: true })
      .use(perfMarkerPlugin)
      .use(a11yPlugin)
      .use(uiBlockerPlugin)
      .use(placeholderPlugin)
      .use(paginationPlugin)
      .use(dateFilterPlugin);
    grid = grid.create(gridOption);
    this.gridrRef.current.appendChild(grid.gridView.render().$el[0]);
    $(this.gridrRef.current).on('click', '.download-recon', e => this.handleDownload(e));
    this.grid = grid;
    this.props.onGridLoad(grid);
  }

  handleDownload(e) {
    const { i18n } = this.props;
    const item = this.grid.gridView.itemOfElement(e.target);
    notificationApi.dismiss(this.floatingBanner);
    if (!item.ReportPath) {
      this.floatingBanner = notificationApi.showWarning(i18n.getString(_TL_('We\'ve encountered an error. Please try again or contact support.')));
      return;
    }
    iframeDownload(item.ReportPath);
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={`${classes.ReconReortGridContainer} row`}>
        <div className="date-filter-container col-md-12" ref={this.dateFilterRef} />
        <div className="recon-grid col-md-12" ref={this.gridrRef} />
        <div className="grid-noresult" />
      </div>
    );
  }
}

HotelCenterReconReportGrid.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  i18n: PropTypes.shape({}).isRequired,
  reportType: PropTypes.string.isRequired,
  onGridLoad: PropTypes.func,
  perfMarker: PropTypes.shape({}).isRequired,
};

HotelCenterReconReportGrid.defaultProps = {
  onGridLoad: () => {},
};

const Wrapped = withDefaultStyles(HotelCenterReconReportGrid, getStyles);
export { Wrapped as HotelCenterReconReportGrid };

export default HotelCenterReconReportGrid;
